import React from "react";
import Subheading from "../../../components/common/Subheading";
import Title from "../../../components/common/Title";

/**
 * Displays metadata about the current log stream task
 *
 * @param {Object} props Component props
 * @param {boolean} props.taskFinished Whether the task has completed
 * @param {number} props.errorCount Number of errors in the log stream
 * @param {number} props.warningCount Number of warnings in the log stream
 * @param {Object} props.logStreamMongoData Additional metadata from MongoDB
 * @returns {JSX.Element} Rendered TaskMetadata component
 */
function TaskMetadata({ taskFinished, errorCount, warningCount, logStreamMongoData }) {
  return (
    <>
      {taskFinished && <Title text={"Scraper Has Terminated Successfully!"} />}
      <Subheading text={`Errors Found: ${errorCount}`} sx={{ color: "#DC143C" }} />
      <Subheading text={`Warnings Found: ${warningCount}`} sx={{ color: "#dcad14" }} />
      <Subheading
        text={
          logStreamMongoData["Scraper Args Hash"]
            ? `Scraper Args Hash: ${logStreamMongoData["Scraper Args Hash"]}`
            : null
        }
      />
      <Subheading
        text={
          logStreamMongoData["Task ID"]
            ? `Container Log Stream: logs/ecs-auto4client-container/${logStreamMongoData["Task ID"]}`
            : null
        }
      />
    </>
  );
}

export default TaskMetadata;
